import React from 'react';
import {isDesktop} from 'react-device-detect';
import {useCreateOrderInAppOrDownload} from 'hooks';

import PaymentPlanCreateDesktop from './components/PaymentPlanCreateDesktop';

interface IPaymentPlanCreateRedirectProps {}

const PaymentPlanCreateRedirect: React.FC<IPaymentPlanCreateRedirectProps> = () => {
  useCreateOrderInAppOrDownload();
  return isDesktop ? <PaymentPlanCreateDesktop /> : null;
};

export default PaymentPlanCreateRedirect;
